export default __webpack_public_path__ + "static/media/bibliotheca-users.99e33f33.svg";